import * as actionTypes from './actionTypes.js';

export const setCalendars = (calendars) => {
  return {
    type: actionTypes.SET_CALENDARS,
    payload: calendars
  };
};

export const setLandingPageData = (landingPageData) => {
  return {
    type: actionTypes.SET_LANDINGPAGE_DATA,
    payload: landingPageData
  };
};

export const setLocations = (locationList) => {
  return {
    type: actionTypes.SET_LOCATIONS,
    payload: locationList
  };
};

export const setPages = (pageList) => {
  return {
    type: actionTypes.SET_PAGES,
    payload: pageList
  };
};

export const setStaffList = (staffList) => {
  return {
    type: actionTypes.SET_STAFF_LIST,
    payload: staffList
  };
};

export const setTextBlocks = (textBlocks) => {
  return {
    type: actionTypes.SET_TEXT_BLOCKS,
    payload: textBlocks
  };
};
